/* eslint-disable */
import React from 'react'
import { Drawer, Box } from '@mui/material'
import NotificationBell from './components/NotificationBell'
import NotificationHeader from './components/NotificationHeader'
import NotificationFilter from './components/NotificationFilter'
import NotificationList from './components/NotificationList'
import EmptyNotifications from './components/EmptyNotifications'
import LoadMoreButton from './components/LoadMoreButton'
import NotificationToast from './components/NotificationToast'
import { useNotifications } from './hooks/useNotification'
import {
  drawerPaperSx,
  notificationListContainerSx,
  notificationListSx,
} from './styles/NotificationStyle'

export default function NotificationDrawer() {
  const {
    open,
    setOpen,
    newNotifs,
    olderNotifs,
    toast,
    setToast,
    filterAnchor,
    setFilterAnchor,
    viewFilter,
    readStatusFilter,
    isLoadingMore,
    progress,
    markRead,
    markAllRead,
    handleLoadMore,
    handleFilterSelect,
    handleReadStatusSelect,
    unreadCount,
    hasNotifications,
  } = useNotifications()

  return (
    <>
      <NotificationBell
        unreadCount={unreadCount}
        onClick={() => setOpen(true)}
      />

      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ sx: drawerPaperSx }}
      >
        <NotificationHeader
          viewFilter={viewFilter}
          readStatusFilter={readStatusFilter}
          onFilterClick={(e) => setFilterAnchor(e.currentTarget)}
          onClose={() => setOpen(false)}
        />

        <NotificationFilter
          anchorEl={filterAnchor}
          open={Boolean(filterAnchor)}
          onClose={() => setFilterAnchor(null)}
          viewFilter={viewFilter}
          readStatusFilter={readStatusFilter}
          onFilterSelect={handleFilterSelect}
          onReadStatusSelect={handleReadStatusSelect}
        />

        <Box sx={notificationListContainerSx}>
          <Box sx={notificationListSx}>
            {!hasNotifications && <EmptyNotifications />}

            {hasNotifications && (
              <NotificationList
                newNotifs={newNotifs}
                olderNotifs={olderNotifs}
                onMarkRead={markRead}
                onMarkAllRead={markAllRead}
              />
            )}
          </Box>

          <LoadMoreButton
            isLoading={isLoadingMore}
            onLoadMore={handleLoadMore}
          />
        </Box>
      </Drawer>

      <NotificationToast
        toast={toast}
        progress={progress}
        onClose={() => setToast(null)}
      />
    </>
  )
}
